import { render, staticRenderFns } from "./BpmnLoopType.vue?vue&type=template&id=518d87c5&scoped=true&"
import script from "./BpmnLoopType.vue?vue&type=script&lang=js&"
export * from "./BpmnLoopType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518d87c5",
  null
  
)

export default component.exports